import { UpdateEvent } from "../../gui/GUIEvents";
import { usePortFilter } from "../../hooks/PortFilter";
import AccountSelect from "./AccountSelect";

export default function AccountFilter(){
    const {account,setAccount} = usePortFilter()
    const onUpdate = (e:UpdateEvent<number>) => setAccount(e.value!)
    return <AccountSelect showAll={true} defaultValue={account} onUpdate={onUpdate}/>
}